import { useContext } from 'react';
import { logEvent } from 'firebase/analytics';

import { useRejectContractMutation } from '@/api/queries/contract';
import { playSound } from '@/common/lib/soundEffect';
import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { ModalContext } from '@/components/Modals/Modal/config';
import { analytics } from '@/firebase';
import { selectSpecContractDataByKind } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

interface UseRejectSpecContractReturnType {
  onClick: () => void;
  isLoading: boolean;
  disabled: boolean;
}

const useRejectSpecContract = (
  kind: SpecContractType | PaidSpecContractType,
): UseRejectSpecContractReturnType => {
  const contract = useAppSelector((state) =>
    selectSpecContractDataByKind(state, kind),
  );
  const userLevel = useAppSelector((state) => state.user.user?.level);
  const { closeModal } = useContext(ModalContext);
  const [rejectContract, { isLoading }] = useRejectContractMutation();

  const sendAnalytics = (): void => {
    if (!analytics || !contract) return;
    logEvent(analytics, 'contract_cancel', {
      reward_cash: contract.cash,
      reward_point: contract.point,
      user_level: userLevel,
      resources_to_complete: JSON.stringify(contract.data),
    });
  };

  const onClick = (): void => {
    if (!contract) return;
    playSound('contracts/delete');
    rejectContract({ contractId: contract.id }).unwrap().then(closeModal);
    sendAnalytics();
  };

  return {
    onClick,
    isLoading,
    disabled: isLoading,
  };
};

export { useRejectSpecContract };
